export const FETCH_USER_EDIT_REQUEST = "FETCH_USER_EDIT_REQUEST";
export const FETCH_USER_EDIT_SUCCESS = "FETCH_USER_EDIT_SUCCESS";
export const FETCH_USER_EDIT_FAILURE = "FETCH_USER_EDIT_FAILURE";